import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClientJS } from "clientjs";
import "./login.css";
import ToastMessage from "../ToastMessage/ToastMessage";
import {
  signIn,
  getCaptcha,
  captchaVerification,
  sendOtp,
  verifyOtp,
} from "../../utils/request"; // Import Api Functions
import loginCodes from "../../utils/loginCodes";
import OTPInput from "react-otp-input";
import Loader from "../Layout/Loader/Loader";

const temp_res_data = {
  url: "http://localhost:3001",
  jwt: "dasdasdSADASWEREWFW$@#FDS%@#RDSFC@#R@",
};

const TemporaryPassword = () => {
  // const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false); // State for toggling password visibility

  // Extract callback URL from URL query parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callbackUrl = queryParams.get("callbackUrl") || temp_res_data.url;
  const clientId = queryParams.get("clientId");
  console.log("clientId", clientId);

  const navigate = useNavigate(); // Hook to navigate to another route

  const client = new ClientJS();
  /**
   * Get the client's fingerprint id
   */
  const fingerprint = client.getFingerprint();

  const otpVerificationData = JSON.parse(
    sessionStorage.getItem("otpVerificationData")
  );

  const handleSubmit = async (event) => {
    console.log("Resend OTP");

    event.preventDefault(); // Prevent default form submission

    // Reset states before each submit attempt
    setIsLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      // If CAPTCHA is successful, proceed with sign-in API
      const userSignInData = {
        email: email,
        password: password,
        browser_id: `${fingerprint}`,
        token: clientId,
      };

      console.log("Sending sign-in request:", userSignInData); // Debug sign-in data

      const signInResponse = await signIn(userSignInData);
      console.log("Sign-in response:", signInResponse); // Debug API response

      // Handle different sign-in response cases
      if (signInResponse?.code === 20 && signInResponse?.accessToken) {
        navigate(`/?clientId=${otpVerificationData?.token}`);
      } else {
        console.error("Login failed, unexpected response:", signInResponse);
        setError("loginFailed");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.message || "loginError");
    } finally {
      setIsLoading(false); // Reset loading state after the operation
    }
  };

  return (
    <div className="flex-container">
      <div className="form-section">
        <div>
          <div>
            <h4 className="title">{"Change Password"}</h4>
            <p className="description">
              {
                "Enter the OTP sent to your email, along with your new password, to update your account password."
              }
            </p>
          </div>

          <div className="form-container">
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"} // Toggle input type
                  id="password"
                  placeholder=" "
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <label htmlFor="password">{"password"}</label>
                <span
                  className="eye-icon"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                  {isPasswordVisible ? (
                    <img
                      src={require("../../assets/eye.svg").default}
                      alt="Show password"
                    />
                  ) : (
                    <img
                      src={require("../../assets/hidden.svg").default}
                      alt="Hide password"
                    />
                  )}
                </span>
              </div>

              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"} // Toggle input type
                  id="password"
                  placeholder=" "
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <label htmlFor="password">{"Confirm password"}</label>
                <span
                  className="eye-icon"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                  {isPasswordVisible ? (
                    <img
                      src={require("../../assets/eye.svg").default}
                      alt="Show password"
                    />
                  ) : (
                    <img
                      src={require("../../assets/hidden.svg").default}
                      alt="Hide password"
                    />
                  )}
                </span>
              </div>
              <div
                className="input-group"
                style={{
                  textAlign: "center", // Vertically centers the text and image
                  display: "flex", // Use flexbox to center the button horizontally
                  justifyContent: "center", // Center button horizontally
                }}
              >
                <button
                  style={{
                    borderColor: "#1890ff",
                    borderRadius: "4px",
                    margin: "30px 0 0 0",
                    width: "100%",
                    // display: "flex", // This ensures the button contents are aligned horizontally
                    justifyContent: "center", // Center the text horizontally
                    // alignItems: "center", // Center the text vertically
                    textAlign: "center", // Ensure text is centered in the button
                  }}
                  onClick={handleSubmit}
                >
                  {isLoading ? <Loader/> : "Submit"}
                </button>
              </div>
              <ToastMessage
                message={error || successMessage}
                type={error ? "error" : "success"}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TemporaryPassword;
